import { Col, Row, Skeleton } from 'antd';
import { useContext, useMemo, memo } from 'react';
import { isEmpty } from 'lodash';
import Caption from '../../../Caption/Caption';
import Icons from '../../../../../configs/icon.config';
import CopyButton from '../../../Copy-button/CopyButton';
import { useGetContactQuery } from '../../importantContactsSlice';
import ListItem from '../../../List-Item/ListItem';
import { TabContext } from '../Context/TabContext';
import { SearchContext } from '../../../Search/Context/SearchContext';
import filterIt from '../../../../../utils/search';
import NoDataCard from '../../../Empty/noDataCard';

function AllTabData() {
  const { data, isLoading: contactDataLoading } = useGetContactQuery();
  const tabKey = useContext(TabContext);
  const searchValue = useContext(SearchContext);

  const contactData = useMemo(() => {
    return data?.results.filter(
      (item: { group: any; name: string | undefined }) =>
        item.group.name === tabKey
    );
  }, [data?.results, tabKey]);

  const filteredValue = useMemo(() => {
    /** duplicate contact data  */
    if (!contactDataLoading) {
      const tempContactData = [...contactData];
      /** removed order, id, and group from data */
      const filterableObject = tempContactData.map(
        ({ order, id, group, ...rest }) => rest
      );
      const filterValue = filterIt(filterableObject, searchValue);
      if (isEmpty(filterValue)) {
        return 'no-data';
      }
      return filterValue;
    }
    return [];
  }, [contactData, contactDataLoading, searchValue]);

  return (
    <div className="md:px-8 md:py-4 px-8 py-4 ">
      <div className="flex items-center mb-6 md:hidden text-[13px]">
        <span className="mr-2">Tap on the phone icon</span>
        <span className="mr-2 mb-1">{Icons.telephone} </span>
        <span className="mr-2"> to call that number</span>
      </div>
      <Row gutter={24}>
        {contactDataLoading && <Skeleton />}
        {filteredValue === 'no-data' ? (
          <div className="flex justify-center w-full">
            <NoDataCard />
          </div>
        ) : (
          filteredValue?.map(
            (
              cd: {
                name: string | undefined;
                phone: string | undefined;
                email: string | undefined;
                location: string | undefined;
              },
              index: number
            ) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <Col key={index} xs={24} sm={24} md={8} className="pb-8">
                  <div className="pb-4">
                    <Caption
                      text_en={cd.name}
                      text_bn={cd.name}
                      color="gray-800"
                      fontWeight="bold"
                      fontSize="2xl"
                    />
                  </div>
                  <ul>
                    {cd.phone && (
                      <ListItem
                        captionWeight="bold"
                        captionSize="lg"
                        captionColor="gray-800"
                        caption_en={cd.phone}
                        caption_bn={cd.phone}
                        icon="telephone"
                        iconColor="text-pink-600 dark:text-[#EB3E8E]"
                        extraFeature={<CopyButton text={cd.phone} />}
                        contacType="phone"
                      />
                    )}
                    {cd.email && (
                      <ListItem
                        captionWeight="bold"
                        captionSize="lg"
                        captionColor="gray-800"
                        caption_en={cd.email}
                        caption_bn={cd.email}
                        icon="mail"
                        iconColor="text-pink-600 dark:text-[#EB3E8E]"
                        extraFeature={<CopyButton text={cd.email} />}
                        contacType="email"
                      />
                    )}
                    {cd.location && (
                      <ListItem
                        captionWeight="bold"
                        captionSize="lg"
                        captionColor="gray-800"
                        caption_en={cd.location}
                        caption_bn={cd.location}
                        icon="location"
                        iconColor="text-pink-600 dark:text-[#EB3E8E]"
                        extraFeature={<CopyButton text={cd.location} />}
                        contacType="location"
                      />
                    )}
                  </ul>
                </Col>
              );
            }
          )
        )}
      </Row>
    </div>
  );
}

export default memo(AllTabData);
